import React from 'react'
import PropTypes from 'prop-types'

import './responsiveEmbed.scss'

const ResponsiveEmbed = ({ children, ratio }) => (
	<div
		className={[
			'o-responsive-embed',
			ratio ? `o-responsive-embed--${ratio}` : '',
		].join(' ')}
	>
		<div className="o-responsive-embed__item">{children}</div>
	</div>
)

ResponsiveEmbed.propTypes = {
	children: PropTypes.node.isRequired,
	ratio: PropTypes.string,
}

ResponsiveEmbed.defaultProps = {
	ratio: '16-9',
}

export default ResponsiveEmbed
